import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const images = [
  "/img/gallery/prace1.jpg",
  "/img/gallery/prace2.jpg",
  "/img/gallery/prace3.jpg",
  "/img/gallery/prace4.jpg",
  "/img/gallery/prace5.jpg",
  "/img/gallery/prace6.jpg",
  "/img/gallery/prace7.jpg",
  "/img/gallery/prace9.jpg",
  "/img/gallery/prace10.jpg",
  "/img/gallery/prace11.jpg",
  "/img/gallery/prace12.jpg",
  "/img/gallery/prace13.jpg",
  "/img/gallery/prace14.jpg",
  "/img/gallery/prace15.jpg",
  "/img/gallery/prace16.jpg",
  "/img/gallery/prace17.jpg",
  "/img/gallery/prace18.jpg",
  "/img/gallery/prace19.jpg",
  "/img/gallery/prace20.jpg",
  "/img/gallery/prace21.jpg",
  "/img/gallery/prace22.jpg",
  "/img/gallery/prace23.jpg",
];

const Gallery = () => {
  return (
    <div className="gallery-container">
      {/* Dekoracyjne kwadraty w tle */}
      <div className="background-squares">
        <div className="square2 red"></div>
        <div className="square white"></div>
      </div>

      {/* Główna galeria */}
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        loop
        autoplay={{ delay: 2000, disableOnInteraction: true }}
        className="main-gallery"
      >
        {images.map((src, index) => (
          <SwiperSlide key={index}>
            <img src={src} alt={`Slide ${index}`} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Gallery;
